import React from 'react'
import CreatedBy from './CreatedBy'
import classNames from 'classnames'

export default ({ className, linkClass }) => {
  const classes = classNames(
    'heimr-created-by__link',
    'heimr-created-by__link--a-la-enell',
    linkClass
  )

  return (
    <CreatedBy className={className} linkClass={linkClass}>
      <a href='https://alaenell.se' className={classes}>
        A LA ENELL
      </a>{' '}
      &{' '}
    </CreatedBy>
  )
}
